import { RouteName } from '@/router/models/route-name';
import { reactive, toValue, watchEffect, type MaybeRefOrGetter } from 'vue';
import { useRouter } from 'vue-router';
import type { Ata } from '../types';

export interface UseAtaTableUnderRemittanceLogicProps {
  initialAtas: Ata[];
  projectId: MaybeRefOrGetter<string>;
}

type UseAtaTableUnderRemittanceLogicReturn = {
  state: { atas: Ata[] };
  action: { select(ata: Ata): void };
};

export const useAtaTableUnderRemittanceLogic = (
  props: UseAtaTableUnderRemittanceLogicProps,
): UseAtaTableUnderRemittanceLogicReturn => {
  const router = useRouter();
  const atas = reactive<Ata[]>([]);

  watchEffect(() => {
    atas.splice(
      0,
      atas.length,
      ...[...props.initialAtas]
        .sort((a, b) => {
          const priorityA = a.priority || Infinity;
          const priorityB = b.priority || Infinity;
          const byPriority = priorityA - priorityB;
          if (byPriority !== 0) return byPriority;
          const aTime = a.deadLine ? new Date(a.deadLine).getTime() : Infinity;
          const bTime = b.deadLine ? new Date(b.deadLine).getTime() : Infinity;
          return aTime - bTime;
        })
        .map((a) => ({ ...a })),
    );
  });

  const action = {
    select(ata: Ata): void {
      router.push({
        name: RouteName.ATADetails,
        params: { id: toValue(props.projectId), ataId: ata.id },
      });
    },
  };

  return {
    state: reactive({ atas }),
    action,
  };
};
